// @file contains attributes related to the native bridge anchor
export const BRIDGED_LINK_TYPE_ATTRIBUTE = 'data-bridged-link'
